<template>
  <div class="field">
    <div class="field-label is-normal" v-if="config.label">
      <label class="label">{{config.label}}</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            type="text"
            :placeholder="config.placeholder"
            :value="config.value"
            :maxlength="config.maxLength ? config.maxLength : 500"
            v-on:input="updateValue($event.target.value)"
          ></textarea>
        </div>
      </div>
      <span class="label-error" v-if="config.error">{{config.message}}</span>
    </div>
  </div>
</template>
<style lang="scss">
@import "./src/bulma/form/input-textarea";
</style>
<script lang="ts">
// @ is an alias to /src
import { Component, Prop, Vue } from 'vue-property-decorator';

import { ITextarea } from './';

@Component({
  name: 'Textarea'
})
class Textarea extends Vue {
  @Prop({ required: true }) public config!: ITextarea;
  @Prop({ required: true }) public value!: string | number;
  public created() {}
  public updateValue(value: string | number) {
    this.$emit('input', value);
  }
}
export default Textarea;
</script>